<!-- 上传附件 -->
<template>
  <el-upload
    ref="uploadAnnexRef"
    name="file"
    :class="['upload-annex', `upload--${status}`]"
    :accept="accept"
    :action="url"
    :headers="{ Authorization: authToken }"
    :data="{ type }"
    :show-text="false"
    :show-file-list="false"
    :disabled="disabled"
    :before-upload="handleBeforeUpload"
    :on-progress="handleOnProgress"
    :on-success="handleOnSuccess"
    :on-error="handleOnError"
  >
    <!-- 未开始 -->
    <div v-if="status === 0" class="upload-annex__notStarted">
      <BaseButton type="default" round :disabled="disabled">
        <i class="el-icon-upload2"></i>
        上传文件
      </BaseButton>
      <span class="annex__notStarted__tips" @click.stop>
        {{ extendTips }}
      </span>
    </div>
    <!-- 上传中 -->
    <div v-if="status === 1" class="upload-annex__uploading">
      <div class="upload-annex__uploading__content"  @click.stop>
        <img src="@@/assets/img/icons/icon_annex.png" />
        <p>
          {{ name }}
          <el-progress 
            color="#15A675"
            :stroke-width="2"
            :show-text="false"
            :percentage="percentage" 
          ></el-progress>
        </p>
      </div>
    </div>
    <!-- 上传成功 -->
    <div v-if="status === 2" class="upload-annex__success">
      <div class="upload-annex__success__content"  @click.stop>
        <img src="@@/assets/img/icons/icon_annex.png" />
        <p :title="name">
          {{ name }}
        </p>
        <i v-if="!disabled" class="el-icon-close" @click="handleReset"></i>
      </div>
      <BaseButton type="default" round :disabled="disabled">
        <i class="el-icon-upload2"></i>
        重新上传
      </BaseButton>
    </div>
  </el-upload>
</template>

<script>
import CONFIG from '@@/config'
import { getToken } from '@@/utils/auth'

export default {
  props: {
    type: {
      type: String,
      default: 'smt_params_1'
    },
    fileUrl: {
      type: String,
      default: ''
    },
    fileName: {
      type: String,
      default: ''
    },
    accept: {
      type: String,
      default: '.rar,.zip,.doc,.docx,.txt,.xls,.xlsx,.csv'
    },
    limitSize: {
      type: Number,
      default: 20
    },
    extendTips: {
      type: String,
      default: '支持扩展名：.rar .zip .doc .docx .txt .xls .xlsx .csv'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      authToken: getToken(),
      status: 0, // 状态： 0-未开始, 1-上传中, 2-上传成功, 3-上传失败
      percentage: 0, // 上传进度条进度
      name: '', // 文件名称
    }
  },
  computed: {
    url() {
      return `${CONFIG.HQPCBA_HOST}/pcba/app/file/fileUpload`
    }
  },
  watch: {
    fileName: {
      handler (newVal) {
        if (newVal && this.status === 0) {
          this.name = newVal
          this.status = 2
        }
        if (!newVal) {
          this.name = ''
          this.status = 0
        }
      },
      immediate: true
    }
  },
  methods: {
    handleEmit(data) {
      this.$emit('input', data)
      this.$emit('change', data)
    },
    // 上传校验
    handleBeforeUpload(file) {
      this.authToken = getToken()

      const { name, size } = file
      const limitSize = this.limitSize
      const isLimit = size / 1024 / 1024 < limitSize
      if (isLimit) {
        this.status = 1
        this.name = name
      } else {
        this.$message.error(`文件大小不能超过 ${limitSize}MB，请重新上传！`)
      }
      return isLimit
    },
    // 上传中
    handleOnProgress(event, file) {
      this.percentage = event.percent
    },
    // 上传成功
    handleOnSuccess(res) {
      const { retCode, result, retMsg } = res || {}
      if (retCode === 0) {
        this.status = 2
        this.handleEmit(result)
      } else {
        this.$message.error(retMsg || '上传失败，请稍等重试！')
        this.handleReset()
      }
    },
    // 上传失败
    handleOnError() {
      this.handleReset()
    },
    // 重置
    handleReset() {
      this.status = 0
      this.percentage = 0
      this.name = ''
      this.handleEmit()
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-annex ::v-deep {
  .el-upload {
    display: block;
    text-align: left;
    color: $--color-text-primary;
    &:focus {
      color: $--color-text-primary;
    }
  }

  .upload-annex__notStarted {
    display: flex;
    align-items: center;
    .annex__notStarted__tips {
      flex: 1;
      margin-left: 10px;
      font-size: 12px;
      color: #C0C4CC;
    }
  }
  .upload-annex__uploading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .upload-annex__uploading__content {
      display: flex;
      align-items: center;
      flex: 1;
      max-width: 100%;
      >p {
        flex: 1;
        margin: 0 4px;
        font-size: 12px;
        color: $--form-color-base;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      >i {
        display: none;
      }
      &:hover {
        >i {
          display: block;
        }
      }
    }
  }
  .upload-annex__success {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .upload-annex__success__content {
      display: flex;
      align-items: center;
      flex: 1;
      max-width: calc(100% - 100px);
      >p {
        max-width: calc(100% - 40px);
        margin: 0 4px;
        font-size: 12px;
        color: $--form-color-base;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      >i {
        display: none;
      }
      &:hover {
        >i {
          display: block;
        }
      }
    }
  }
}
</style>